export default __webpack_public_path__ + "static/media/invitation.0c6e9847.png";